import { memo, useCallback, useRef } from "react"

import { usePaginationFromURL } from "hooks/usePaginationFromURL"

import { FilterPopover } from "components/FilterComponents/FilterPopover/FilterPopover"
import { FilterType } from "components/FilterComponents/FilterPopover/types"

import { OrderFilterKey } from "../../constant"

export interface FreeSearchFilterProps {
    label: string
    filterKey: OrderFilterKey
    handleUpdateParam: (paramName: string, paramValue: string) => void
    minLength?: number
    maxLength?: number
}

export const FreeSearchFilter = memo(({ label, filterKey, handleUpdateParam, minLength, maxLength }: FreeSearchFilterProps) => {
    const urlParams = usePaginationFromURL('orders')

    const currentValue = urlParams[filterKey as keyof typeof urlParams] as string || ''

    const handleUpdateParamRef = useRef(handleUpdateParam)
    const filterKeyRef = useRef(filterKey)

    handleUpdateParamRef.current = handleUpdateParam
    filterKeyRef.current = filterKey

    const handleChange = useCallback((value: string) => {
        handleUpdateParamRef.current(filterKeyRef.current, value)
    }, [])

    return (
        <FilterPopover
            label={label}
            filterType={FilterType.FREE_SEARCH}
            onChange={handleChange}
            selectedItems={currentValue ? [currentValue] : []}
            minLength={minLength}
            maxLength={maxLength}
        />
    )
})